// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form-container {
  background-color: rgba(255, 255, 255, 0.8980392157);
  border-radius: 0.21vw;
  box-shadow: 0 0 0 0.21vw rgba(190, 190, 190, 0.2509803922);
  margin: auto;
}
.contact-form-container .contact-form-wrapper .close-dialog {
  align-items: center;
  margin: 1.11vw 0 0 0;
}
.contact-form-container .contact-form-inner-wrapper {
  margin: 2.22vw 1.11vw;
  width: 32vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contact-form-container .close-dialog {
  position: relative;
  right: 1.25vw;
  top: 0.15vw;
}
.contact-form-container .contact-info-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: space-between;
}
.contact-form-container .firstname,
.contact-form-container .lastname {
  margin: 0 !important;
}
.contact-form-container .contact-form-inner-wrapper form {
  width: fit-content;
  margin: auto;
}
.contact-form-container label {
  display: block;
  font-weight: 400;
  font-size: 0.902vw;
  line-height: 1.25vw;
  color: #3a3a3a;
  margin: 0 0.2775vw;
}
.contact-form-container form div {
  margin: 1.11vw 0.8325vw;
}
.contact-form-container input,
.contact-form-container textarea {
  padding: 0.555vw;
  border-radius: 0.21vw;
  border: 1px solid #737373;
  width: -webkit-fill-available;
  margin: 0.2775vw;
}
.contact-form-container .required-field {
  color: #ee3a24;
  font-weight: 400;
  font-size: 0.902vw;
  line-height: 1.25vw;
}
.contact-form-container .submit {
  text-align: center;
}
.contact-form-container .submit button {
  background-color: #ee3a24;
  border-radius: 0.21vw;
  padding: 0.8325vw 3.33vw;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 0.902vw;
  line-height: 1.25vw;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/ContactInfo.scss"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,qBAAA;EACA,0DAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;EACA,oBAAA;AACJ;AACE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AACJ;AACE;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACE;;EAEE,oBAAA;AACJ;AACE;EACE,kBAAA;EACA,YAAA;AACJ;AACE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AACE;EACE,uBAAA;AACJ;AACE;;EAEE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;AACJ;AACE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACE;EACE,kBAAA;AACJ;AACE;EACE,yBAAA;EACA,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACJ","sourcesContent":[".contact-form-container {\n  background-color: #ffffffe5;\n  border-radius: 0.21vw;\n  box-shadow: 0 0 0 0.21vw #bebebe40;\n  margin: auto;\n\n  .contact-form-wrapper .close-dialog {\n    align-items: center;\n    margin: 1.11vw 0 0 0;\n  }\n  .contact-form-inner-wrapper {\n    margin: 2.22vw 1.11vw;\n    width: 32vw;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .close-dialog {\n    position: relative;\n    right: 1.25vw;\n    top: 0.15vw;\n  }\n  .contact-info-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    align-items: center;\n    justify-content: space-between;\n  }\n  .firstname,\n  .lastname {\n    margin: 0 !important;\n  }\n  .contact-form-inner-wrapper form {\n    width: fit-content;\n    margin: auto;\n  }\n  label {\n    display: block;\n    font-weight: 400;\n    font-size: 0.902vw;\n    line-height: 1.25vw;\n    color: #3a3a3a;\n    margin: 0 0.2775vw;\n  }\n  form div {\n    margin: 1.11vw 0.8325vw;\n  }\n  input,\n  textarea {\n    padding: 0.555vw;\n    border-radius: 0.21vw;\n    border: 1px solid #737373;\n    width: -webkit-fill-available;\n    margin: 0.2775vw;\n  }\n  .required-field {\n    color: #ee3a24;\n    font-weight: 400;\n    font-size: 0.902vw;\n    line-height: 1.25vw;\n  }\n  .submit {\n    text-align: center;\n  }\n  .submit button {\n    background-color: #ee3a24;\n    border-radius: 0.21vw;\n    padding: 0.8325vw 3.33vw;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    font-size: 0.902vw;\n    line-height: 1.25vw;\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
